<template>
    <div>
        <!-- Create Admission Form Button -->
        <b-button v-if="!admissiondesk" size="sm" variant="info" @click="showForm = true;">
            <i class="fas fa-plus-square text-white" style="font-size: 16px !important;"></i>
            Create
        </b-button>

        <!-- Admission Form List -->
        <table class="table table-striped table-bordered mt-3" v-if="admissionForms.length > 0">
            <thead class="thead-dark text-left">
                <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th v-if="!admissiondesk"></th>
                    <th v-if="!admissiondesk"></th>
                    <!-- <th></th> -->
                    <th>Academic Year</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th v-if="!admissiondesk">Public URL</th>
                    <th v-if="!admissiondesk"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(form, index) in admissionForms" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ form.name }}
                        <b-badge v-if="form.form_type == 1" pill variant="primary"
                            style="font-size: 10px; font-weight: 600; color: #fff;">
                            Enquiry/Admission Form
                        </b-badge>
                    </td>
                    <td v-if="!admissiondesk">
                        <a @click="createSection(form.id)" class="text-primary font-weight-bold text-decoration-none"
                            style="cursor: pointer;">
                            Create Form
                        </a>
                    </td>
                    <td>
                        <a @click="approvalOverview(form.id)" class="text-primary font-weight-bold text-decoration-none"
                            style="cursor: pointer;">
                            Approval Over View
                        </a>
                    </td>
                    <td>{{ form.academic_year }}</td>
                    <td>{{ formatDate(form.start_date) }}</td>
                    <td>{{ formatDate(form.end_date) }}</td>

                    <td class="text-center" v-if="!admissiondesk">
                        <span v-if="form.id" class="text-info text-center btn p-0 m-0" :id="'url' + index">
                            <i class="fas fa-link" style="font-size: 15px!important;"></i>
                        </span>
                        <span class="text-danger" v-else>No Link!</span>

                        <b-popover v-if="form.id" :target="'url' + index" triggers="hover" placement="top">
                            <template #title>Click the link to copy</template>
                            <span class="text-info btn p-0 m-0" :ref="'url' + index" @click="copyLink(index)">
                                {{ publicEventUrl }}admission_form/{{ form.id }}
                            </span>
                        </b-popover>
                    </td>
                    <td v-if="!admissiondesk">
                        <!-- Edit -->
                        <i class="fas fa-edit text-info ml-2" style="font-size: 15px!important;cursor: pointer;"
                            @click="editAdmissionForm(form)"></i>

                        <!-- View -->
                        <i class="fas fa-eye text-success ml-2" style="font-size: 15px!important;cursor: pointer;"
                            @click="viewAdmissionForm(form.id)"></i>
                    </td>

                </tr>
            </tbody>
        </table>


        <!-- Admission Form Section List -->
        <table class="table table-striped table-bordered mt-3" v-if="admissionFormSections.length > 0">
            <thead class="thead-dark text-left">
                <tr>
                    <th>No.</th>
                    <th>Section</th>
                    <th></th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="(section, index) in admissionFormSections" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ section.name }}</td>
                    <td>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-sm btn-info me-2 mr-2" @click="viewData(section.id)">
                                Approve
                            </button>

                            <!-- Show Order -->
                            <div v-if="getApprover(section)">
                                <small class="badge bg-secondary">
                                    Order: {{ getApprover(section).order }}
                                </small>
                            </div>
                        </div>
                    </td>


                </tr>
            </tbody>
        </table>

        <!-- Show Admission Form Component when Proceed is clicked -->
        <b-modal v-model="showForm" title="Admission Form" hide-footer hide-header centered size="md"
            @hidden="selectedForm = null">
            <admission-form-create :formData="selectedForm" @closeForm="showForm = false"
                @reloadAdmissionFormList="getAdmissionForms()" />
        </b-modal>


    </div>
</template>

<script>
import AdmissionFormCreate from './admissionFormCreate.vue';

export default {
    props: ['admissiondesk'],
    async created() {
        this.publicEventUrl = process.env.VUE_APP_BACE_URL;
        await this.fetchInstitutionFaculties();
        await this.getAdmissionForms();
    },

    components: { AdmissionFormCreate },

    watch: {
        formData: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.admissionform = { ...newValue };
                } else {
                    this.resetForm();
                }
            },
        },
    },

    data() {
        return {
            showForm: false,
            admissionForms: [],
            admissionFormSections: [],
            approver: null,
            selectedForm: null, // Stores the form data when editing
            facultyOptions: []
        };
    },
    methods: {
        getFacultyName(id) {
            const faculty = this.facultyOptions.find(f => f.id === id);
            return faculty ? faculty.name.trim() : 'Unknown';
        },
        async fetchInstitutionFaculties() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/faculties`;
            try {
                const response = await this.$axios.get(url);
                this.facultyOptions = response.data
                    .filter(staff => staff.enroll_status === 'active')
                    .map(staff => ({
                        id: staff.id,
                        name: `${staff.first_name} ${staff.last_name}`
                    }));
            } catch (error) {
                console.error("Error fetching faculty data:", error);
            }
        },
        getApprover(section) {
            return section.approvers.find(a => a.institution_user_id == this.approver) || null;
        },
        approvalOverview(admissionformId) {
            const routeData = this.$router.resolve({
                name: 'ViewAdmissionFormStudentViaSections',
                params: {
                    admissionform_id: admissionformId
                },
            });
            window.open(routeData.href, "_blank");

        },
        viewAdmissionForm(admissionform_id) {
            const routeData = this.$router.resolve({
                name: 'ViewAdmissionFormFullData',
                params: {
                    admissionform_id: admissionform_id,
                },
            });
            window.open(routeData.href, "_blank");
        },
        viewData(section_id) {
            const routeData = this.$router.resolve({
                name: 'ViewAdmissionFormStudentViaQuestions',
                params: {
                    admissionform_section_id: section_id,
                    admissiondesk: this.admissiondesk,
                    adminrole_admissiondesk: false
                },
            });
            window.open(routeData.href, "_blank");
        },
        createSection(admissionformId) {
            const routeData = this.$router.resolve({
                name: 'AdmissionFormSection',
                params: { admissionform_id: admissionformId },
            });
            window.open(routeData.href, "_blank");
            this.$store.commit('admissionform/SET_ADMISSION_FORM_ID', admissionformId);
        },
        async copyLink(index) {
            var elementSelect = this.$refs["url" + index];
            let Url = await elementSelect[0].innerHTML;
            this.$clipboard(Url);
            this.$toast.info("Copied to clipboard", {
                position: "top-right",
                duration: 3000,
            });
        },
        resetForm() {
            this.admissionform = { name: "", academic_year: "", start_date: "", end_date: "" };
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        async getAdmissionForms() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms?is_admissiondesk=${this.admissiondesk}&is_approval=${true}`;
            await this.$axios
                .get(url)
                .then((response) => {
                    this.admissionForms = response.data.admissionforms ?? [];
                    this.admissionFormSections = response.data.sections ?? [];
                    this.approver = response.data.approver ?? [];
                })
                .catch((error) => {
                    let errortxt = error.response.data.message ?? 'Failed to Submit, please try agin';
                    this.$toast.error(errortxt, {
                        position: "top",
                        duration: 7000,
                    });
                });
        },

        editAdmissionForm(form) {
            this.selectedForm = { ...form }; // Clone form data to avoid modifying the list directly
            this.showForm = true;  // Open the form modal
        },

    },
};
</script>
